import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/SLEEP';

export const {action: show} = createAction(
    `${domain}/SHOW`,
    (institutionId, childIds, childNames, napType, canCheckOn) => ({
        institutionId,
        childIds,
        childNames,
        napType,
        canCheckOn,
    }),
);

export const {action: hide} = createAction(`${domain}/HIDE`);

export const {action: toggleForm} = createAction(`${domain}/SHOW_FORM`);

export const {
    action: nap,
    success: napSuccess,
    failed: napFailure,
} = createAction(`${domain}/SLEEP`, (childIds, value, names, napType) => ({childIds, value, names, napType}));

export const {
    action: checkOn,
    success: checkOnSuccess,
    failed: checkOnFailure,
} = createAction(`${domain}/CHECK_ON`, (childIds, names) => ({childIds, names}));
